// extracted by mini-css-extract-plugin
export default {"serviceList":"_5UcAtPiUyxNWg2wcdhyQeh","serviceListHeading":"_3feArClHHtrmmwgI548hvZ","service":"_3jhFPE4rLIRLkOC7bJcF9R"};